import React from "react";
import { trackEvent } from "../../lib/matomo";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import LogoBlue from "../../assets/icons/peppa_logo_blue.svg";

export default function BillingCancel() {
  const navigate = useNavigate();
  useEffect(() => { try { trackEvent("billing", "cancel_page_viewed"); } catch(_) {} }, []);

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-rose-50 via-background to-background dark:from-rose-950/40 dark:via-background dark:to-background flex items-center justify-center px-4">
      <div className="absolute inset-x-0 -top-20 h-72 bg-[radial-gradient(40%_60%_at_50%_0%,rgba(244,63,94,0.25),transparent)] pointer-events-none" />
      <Card className="max-w-lg w-full shadow-xl border-muted">
        <CardHeader>
          <div className="flex items-center justify-between mb-2">
            <img src={LogoBlue} alt="Peppa" className="h-6" />
          </div>
          <div className="flex items-start gap-4">
            <div className="h-12 w-12 rounded-full bg-gradient-to-br from-rose-500 to-red-600 flex items-center justify-center shadow-md">
              <span className="text-white text-xl">!</span>
            </div>
            <div>
              <CardTitle className="text-foreground text-2xl">Paiement annulé</CardTitle>
              <CardDescription className="mt-1">La transaction a été interrompue.</CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <p className="text-foreground/90 leading-relaxed">
            Pas de frais engagés. Revenez tester PeppaCorp à tout moment !
            </p>
            <div className="rounded-lg border-muted bg-muted/30 p-3 text-sm text-foreground/80">
              Conseil: Pas d’inspiration ? Nos exemples vous aident à démarrer rapidement.
            </div>
            <div className="pt-2">
              <Button className="w-full h-11 text-base" variant="secondary" onClick={() => navigate("/", { replace: true })}>Retour à l’accueil</Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}


